import { aiSelectData } from '@/pages/ISWAN_CHAT/components/AISelectMenu/index.data';
import { useModel } from '@umijs/max';

export const useAiMeta = () => {
  const [aiType] = useModel('ISWAN_CHAT.aiType');

  const name = (() => {
    const item = aiSelectData.find((e) => e.value === aiType);
    if (item === undefined) return '';
    return item.label;
  })();

  const usage = (() => {
    switch (aiType) {
      case 'Chat':
        return '我可以帮你搜索、答疑、写作，请把你的任务交给我吧 ~';
      case 'Knowledge':
        return '我可以帮你查找专有知识 ~';
      case 'App':
        return '我可以帮你查找智能系统数据 ~';
      case 'Decision':
        return '我可以帮你进行智脑决策 ~';
      case 'Analyze':
        return '我可以帮你进行数据分析 ~';
      case 'Robot':
        return '我可以帮你控制或执行自动化任务～';
    }
  })();

  return {
    name,
    usage,
  };
};
